import {
  ComponentTemplateDto,
  ComponentTemplatePrivacyType,
} from "@growth-machine-llc/stridist-api-client";
import React from "react";
import { LibraryPrivacyType } from "../../constants";
import {
  GenericTemplateTypeBadge,
  privacyTooltip,
} from "../badge/LibraryPrivacyTypeBadge";

interface ComponentTemplatePrivacyBadgeProps {
  template: ComponentTemplateDto;
  size?: number;
  showLabel?: boolean;
}

const PROGRAM_TO_LIBRARY_PRIVACY_MAP = {
  [ComponentTemplatePrivacyType.PUBLIC]: LibraryPrivacyType.PUBLIC,
  [ComponentTemplatePrivacyType.PRIVATE]: LibraryPrivacyType.PRIVATE,
  // TODO_COMPONENTS_TEAM_LIBRARY: Handle team component templates
  // [ComponentTemplatePrivacyType.TEAM]: LibraryPrivacyType.TEAM,
};

const mapComponentTemplatePrivacyType = (
  type: ComponentTemplatePrivacyType,
): LibraryPrivacyType => PROGRAM_TO_LIBRARY_PRIVACY_MAP[type];

export function ComponentTemplatePrivacyBadge({
  template,
  size = 40,
  showLabel = true,
}: ComponentTemplatePrivacyBadgeProps) {
  const privacyType: LibraryPrivacyType = mapComponentTemplatePrivacyType(
    template.privacy,
  );

  const tooltip = privacyTooltip("component template", privacyType);

  return (
    <GenericTemplateTypeBadge
      type={privacyType}
      owner={
        template.coachInfo
          ? {
              photoUrl: template.coachInfo.coachPhotoUrl,
              displayName: template.coachInfo.coachName,
            }
          : undefined
      }
      tooltip={tooltip}
      size={size}
      showLabel={showLabel}
    />
  );
}
